export const getServerBaseUrl = () => {
  return window.location.host;
};

export const getStandingSocketUrl = () => {
  return `${getServerBaseUrl()}/api/sapphire/standing`;
};
